import LegalAgreementsWrapper from 'features/reactivation/screens/LegalAgreements/LegalAgreementsWrapper';
import React from 'react';

export default function Page() {
  return <LegalAgreementsWrapper />;
}
